import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import CustomInputLabel from "../../../../../components/CustomInputLabel";
import CustomInput from "../../../../../components/CustomInput";
import CustomButton from "../../../../../components/CustomButton";
import PelakInput from "./PeleakInput";
import CustomAutoComplete from "../../../../../components/CustomAutoComplete";
import CheckCircle from "../../../../../../media/images/icons/check-circle";
import { PreventInputAlpha } from "../../../../../../utils/functions";

interface Props {
  smartCard: {
    loading: boolean;
    name: string;
    value: string;
    error?: boolean;
    errorMessage?: string | false;
    handleChange: (e: React.ChangeEvent<any>) => void;
    disabled: boolean;
  };

  loaderType: {
    options: any[];
    inputValue: string;
    handleChangeInput: React.Dispatch<React.SetStateAction<string>>;
    autoCompleteType: string;
    autoCompleteSelected: any;
    error?: boolean;
    errorMessage?: string | false;
    disabled?: boolean;
  };
  loaderTypeGroup: {
    value: string | null;
  };

  pelakValues: any;

  inquarySmartCardFormik: any;

  handleChangeAutoComplete: (selected: any, type: string | undefined) => void;
  handleChangeInput: (e: React.ChangeEvent<any>) => void;
  handleSubmitArmadaInfoForm: () => void;
  handleSubmitLoaderInfoForm: () => void;
}

export default function ArmadaInfo(props: Props) {
  const {
    handleChangeAutoComplete,
    handleSubmitArmadaInfoForm,
    handleSubmitLoaderInfoForm,
    loaderType,
    loaderTypeGroup,
    smartCard,
    pelakValues,
    inquarySmartCardFormik,
  } = props;

  const theme = useTheme();

  return (
    <Box
      sx={{
        marginTop: "16px",
        width: "100%",
        backgroundColor: "bgColor.white",
        padding: "16px",
        borderRadius: "16px",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "600",
          color: "secondary.dark",
          fontSize: "16px",
        }}
      >
        ثبت مشخصات ناوگان
      </Typography>
      <Box
        sx={{
          marginTop: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            // border: "1px solid gray",
          }}
        >
          <CustomInputLabel required>{"شماره کارت هوشمند"}</CustomInputLabel>

          <CustomInput
            name={smartCard.name}
            value={smartCard.value}
            handelChange={(e) => {
              if (e.target.value.length > 7) return;
              PreventInputAlpha(e, smartCard.handleChange);
            }}
            error={smartCard.error}
            errorMessage={smartCard.errorMessage}
            placHolder="شماره 7 رقمی کارت هوشمند ناوگان "
            // disabled={smartCard.disabled}
            endAdornment={
              <CustomButton
                loading={smartCard.loading}
                onClick={handleSubmitLoaderInfoForm}
                flexDirection="row"
                title="استعلام"
                justifyContent="center"
                bgColor="primary.main"
                fSize="14px"
                px="20px"
                py="6px"
                borderRadius="8px"
                // icon2={<ArrowLeftCircle size={32} />}
              />
            }
          />
        </Box>
        <Box>
          <CustomInputLabel required>{"نوع بارگیر"}</CustomInputLabel>
          <CustomAutoComplete
            // disabled={loaderType.disabled}
            inputValue={loaderType.inputValue}
            setInputValue={loaderType.handleChangeInput}
            type={loaderType.autoCompleteType}
            placeHolder="نوع بارگیر ناوگان خود را انتخاب کنید"
            setValue={handleChangeAutoComplete}
            value={loaderType.autoCompleteSelected}
            error={loaderType.error}
            errorMessage={loaderType.errorMessage}
            options={loaderType.inputValue ? loaderType.options : []}
            // innerIcon={
            //   <LocationOutline size={18} color={theme.palette.textColor.light} />
            // }
          />
        </Box>
        <Box>
          <CustomInputLabel>{"گروه بارگیری"}</CustomInputLabel>
          <Box
            sx={{
              backgroundColor: theme.palette.primary[50],
              textAlign: "center",
              color: "primary.main",
              padding: "16px 0px",
              borderRadius: "16px",
            }}
          >
            {loaderTypeGroup.value ? loaderTypeGroup.value : "-------"}
          </Box>
        </Box>
        <Box
          sx={{
            marginTop: "8px",
            // border: "1px solid gray",
          }}
        >
          <CustomInputLabel required>
            {"پلاک خود را وارد کنید"}
          </CustomInputLabel>

          <PelakInput {...pelakValues} />
        </Box>
        <CustomButton
          // loading={loading}
          disabled={
            !inquarySmartCardFormik.values.smartCard || !smartCard.value
          }
          onClick={handleSubmitArmadaInfoForm}
          flexDirection="row"
          title="ثبت اطلاعات بارگیر"
          justifyContent="center"
          bgColor="success.main"
          width="100%"
          fSize="16px"
          px="10px"
          py="10px"
          borderRadius="10px"
          icon1={<CheckCircle size={32} />}
          mt="16px"
        />
        {/* <CustomButton
          // loading={loading}
          onClick={handleSubmitArmadaInfoForm}
          flexDirection="row"
          title="تکمیل مرحله و ادامه"
          justifyContent="center"
          bgColor="secondary.main"
          width="100%"
          fSize="16px"
          px="10px"
          py="10px"
          borderRadius="10px"
          icon2={<ArrowLeftCircle size={32} />}
          mt="16px"
        /> */}
      </Box>
    </Box>
  );
}
